import * as angular from "angular";
import {IController} from "angular";
import {SplitService} from "../../../commons/services/split-service.service";

export class PlanningJobOverviewCtrl implements IController {

  job: any;
  onClose: Function;
  onRouteInfoClick: Function;

  public settings: any;
  public taskColorByPurpose: any;


  /* @ngInject */
  constructor(private tasksConstants, private splitService: SplitService) {
      this.taskColorByPurpose = this.tasksConstants.typesToColor;
  }

  $onInit() {
    this.settings = this.splitService.getSitePackageDetailsSettings();
  }

}

angular
  .module('bringoz.admin.planning')
  .component('planningJobOverview', {
    bindings: {
      job: '<',
      onClose: '&',
      onRouteInfoClick: '&'
    },
    template: require('./planning-job-overview.html').default,
    controller: PlanningJobOverviewCtrl
  });
